import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

import TimesheetApprovalsContainer from './TimesheetApprovalsContainer';
import { queryCurrentPayPeriodGQL } from '../graphql/PayPeriodGQL';
import { dispatchSelectSupervisor, initPage } from '../actions';
import { getCorpAdminFeature, getUser } from '../../authentication/selectors';

const mapStateToProps = (state) => {
  return {
    currentlyLoggedInUser: getUser(state),
    currentSupervisorId: state.timesheetApprovals.currentSupervisorId,
    isCorpAdmin: getCorpAdminFeature(state),
  };
};

const mapDispatchToProps = {
  dispatchSelectSupervisor,
  initPageAction: initPage,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withInitPage = lifecycle({
  componentWillMount() {
    this.props.initPageAction();
  },
});

// ORDER MATTERS. If you want redux to put the props in required for queries
// you better withRedux FIRST
const enhance = compose(
  withRedux,
  queryCurrentPayPeriodGQL,
  withInitPage,
);

export default enhance(TimesheetApprovalsContainer);
